export const LIKE = 'LIKE' as const
export const UNLIKE = 'UNLIKE' as const
